import { useState } from 'react';
import { AxiosError } from 'axios';
import useToast from 'hooks/useToast';
import { PHONE_REGEX } from 'constant/regex';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import { useQRStore } from '../store/useQRStore';
import { useSendVerificationCodeMutation } from '../api/mutations';

export const useSendVerificationCode = () => {
  const toast = useToast();
  const [error, setError] = useState('');
  const { mobileNumber, setCodeToVerify } = useQRStore();
  const { goToVerifyCode } = useQRScreenNavigation();

  const validatePhoneNumber = (value: string) => {
    if (!value) {
      setError('Phone number is required');
      return false;
    }
    if (!PHONE_REGEX.test(value)) {
      setError('Invalid phone number format');
      return false;
    }
    setError('');
    return true;
  };

  const {
    mutate: sendVerificationCode,
    isPending: sendVerificationCodeLoading,
  } = useSendVerificationCodeMutation({
    onSuccess: (res) => {
      const responseMessage = res?.data?.message;
      toast.success(responseMessage ?? 'Success');
      goToVerifyCode();
    },
    onError: (err: AxiosError) => {
      const errorMessage = (err?.response?.data as { message: string })
        ?.message;
      if (errorMessage) {
        toast.error(errorMessage);
      } else {
        toast.error('Error occurred. Please try again later');
      }
    },
  });

  const handleSendVerificationCode = () => {
    setCodeToVerify('');
    if (!validatePhoneNumber(mobileNumber)) return;
    sendVerificationCode({ phone_number: mobileNumber });
  };

  return {
    error,
    handleSendVerificationCode,
    sendVerificationCodeLoading,
  };
};
